/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-300) var(--nve-ref-size-400);
  --gap: var(--nve-ref-space-sm);
  width: 100%;
  height: 100%;
  flex: 1;
  justify-content: stretch;
  flex-direction: column;
  display: flex;
  overflow: auto;
  gap: var(--gap);
  contain: none;
  scrollbar-color: var(--nve-sys-scrollbar-thumb-color) var(--nve-sys-scrollbar-track-color);
  scrollbar-width: var(--nve-sys-scrollbar-width);
}

[internal-host] {
  background: var(--background);
  padding: var(--padding);
  height: 100%;
  width: 100%;
  flex: 1;
}

::slotted(nve-menu) {
  --width: 100%;
}
